export var AgreementType;
(function (AgreementType) {
    AgreementType["COMMODITY"] = "Commodity";
    AgreementType["EMOBILITY"] = "emobility";
    AgreementType["REIMBURSEMENT"] = "Reimbursement";
    AgreementType["LEASE"] = "Lease";
})(AgreementType || (AgreementType = {}));
